import React from 'react'

/* FooterContainer */
const FooterContainer = ({ children, className }) => {
  return (
    <div className={`grid lg:py-10 lg:border-t border-white/20 first:border-none first:pt-0 last:pb-0 ${className || ''}`}>
      {children}
    </div>
  )
}

export default FooterContainer